// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Czut","title":"Images45_title__3Lhxx","images":"Images45_images__2NVV_"};